import {
  DeckMode,
  MER,
  OrientationInfo,
  DeviceOrientation,
  SpacedRepModuleConfig as BackendSpacedRepModuleConfig,
} from '@longtail-education/superprep-data-model-frontend'

/**
 * Represents a spaced repetition module configuration with extended functionality for the frontend.
 */
export class SpacedRepModuleConfig extends BackendSpacedRepModuleConfig {
  /** The unique identifier of the module. */
  declare id: string

  /**
   * Constructor for creating a new SpacedRepModuleConfig object.
   * @param options An object containing configuration options for the spaced repetition module.
   */
  constructor(
    options: Partial<BackendSpacedRepModuleConfig> & {id: string},
  ) {
    const id = options.id
    const cardMER = options?.cardMER ?? (Object.fromEntries(Array(5).fill(1).map((_, i) => [`mer${i}`, Array(13).fill(0, 0, 1).fill(3, 1)])) as unknown as MER)
    const dailyStudyCount = options?.dailyStudyCount ?? Array(5).fill(1).map((_, i) => 5 * (10 + i))
    const deckLength = options?.deckLength ?? [9, 15, 15, 17, 17]
    const deckMode = options?.deckMode ?? DeckMode.Deep
    const orientationInfo = options?.orientationInfo ?? {phone: DeviceOrientation.Vertical,tablet: DeviceOrientation.Horizontal} as OrientationInfo
    const speedyFactor = options?.speedyFactor ?? Array(5).fill(0.1)
    const nonSpeedyFactor = options?.nonSpeedyFactor ?? Array(5).fill(2.2)
    const thirdChanceFactor = options?.thirdChanceFactor ?? Array(5).fill(0.2)
    const speedyAnswerTime = options?.speedyAnswerTime ?? Array(5).fill(1.2)
    const rightAnswerDisplayTime = options?.rightAnswerDisplayTime ?? Array(5).fill(0.99)
    const wrongAnswerDisplayTime = options?.wrongAnswerDisplayTime ?? Array(5).fill(3)
    const rightMax = options?.rightMax ?? [8, 10, 13, 14, 15]
    const rightMin = options?.rightMin ?? [6, 7, 7, 8, 8]
    const wrongMax = options?.wrongMax ?? [7, 10, 11, 12, 13]
    const wrongMin = options?.wrongMin ?? [4, 5, 5, 6, 6]

    super(id, cardMER, dailyStudyCount, deckLength, deckMode, orientationInfo, speedyFactor, nonSpeedyFactor, thirdChanceFactor, speedyAnswerTime, rightAnswerDisplayTime, wrongAnswerDisplayTime, rightMax, rightMin, wrongMax, wrongMin)
  }
}
